import { Stack, Text } from 'shell/components';
import {
    DEFAULT_FEEDBACK_LANGUAGE_LEVEL,
    DEFAULT_FEEDBACK_SUGGESTION_LENGTH,
    DEFAULT_FEEDBACK_TONE,
} from 'utils/constants';
import { getLanguageLevelText, getSuggestionLengthText, getToneText } from 'utils/helper';

export const getFeedbackTypeName = (settings, t) =>
    ({
        system: t('feedback-section.system-based-feedback', 'General & Detailed Feedback'),
        rubric: t('feedback-section.rubric-based-feedback', 'Rubric-Based Feedback'),
        templated: t('feedback-section.templated-feedback', 'Smart Feedback Templates'),
        custom: t('feedback-section.custom-feedback', 'Custom Feedback Structure'),
    })[settings.structure];

const FeedbackSettingsDetails = ({ settings, additionalInstructions, t }) => {
    switch (settings.structure) {
        case 'system':
        case 'rubric':
            return (
                <>
                    <SettingRow
                        label={t('feedback-section.settings.suggestion-length', 'Length of each suggestion')}
                        value={getSuggestionLengthText(
                            settings.suggestionLength || DEFAULT_FEEDBACK_SUGGESTION_LENGTH,
                            t
                        )}
                    />
                    <SettingRow
                        label={t('feedback-settings.language-level.title', 'Language level')}
                        value={getLanguageLevelText(settings.languageLevel || DEFAULT_FEEDBACK_LANGUAGE_LEVEL, t)}
                    />
                    <SettingRow
                        label={t('feedback-settings.tone.feedback-title', 'Feedback tone')}
                        value={getToneText(settings.tone || DEFAULT_FEEDBACK_TONE, t)}
                    />
                    <SettingRow
                        label={t('additional-instructions', 'Additional instructions')}
                        value={additionalInstructions || t('common:ui.none', 'None')}
                    />
                </>
            );
        case 'custom':
            return (
                <SettingRow
                    label={t('feedback-section.settings.instructions-for-ai', 'Instructions for the AI')}
                    value={settings.customInstructions || t('common:ui.none', 'None')}
                />
            );
        case 'templated':
            return (
                <Text color={'light'}>
                    {t('feedback-section.settings.advanced', 'See advanced feedback settings.')}
                </Text>
            );
        default:
            return null;
    }
};

const SettingRow = ({ label, value }) => (
    <Stack direction={'row'} spacing={1}>
        <Text color={'light'}>{label}:</Text>
        <Text>{value}</Text>
    </Stack>
);

export default FeedbackSettingsDetails;
